import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";

import { getCompareDateRange, getDateRange } from "../components/BetaChannelTrafficChartContainer/utils";

const useSubtitleFilters = (isMTDActive = false) => {
    const { params } = useCurrentStateAndParams();
    const { webSource, country, duration, comparedDuration } = params;
    const durationObject = useMemo(
        () => DurationService.getDurationData(duration, comparedDuration),
        [duration, comparedDuration],
    );
    const [fromDate, toDate] = getDateRange(durationObject, isMTDActive); // real date range which can be affected by MTD
    const [compareFromDate, compareToDate] = getCompareDateRange(durationObject);

    const subtitleFilters = useMemo(
        () => [
            {
                filter: "date",
                value: {
                    from: fromDate.valueOf(),
                    to: toDate.valueOf(),
                    useRangeDisplay: duration !== "28d" && fromDate.format("YYYY-MM") !== toDate.format("YYYY-MM"),
                    compareFrom: compareFromDate && compareFromDate.valueOf(),
                    compareTo: compareToDate && compareToDate.valueOf(),
                },
            },
            {
                filter: "country",
                countryCode: country,
                value: CountryService.getCountryById(country)?.text,
            },
            {
                filter: "webSource",
                value: webSource,
            },
        ],
        [fromDate, toDate, country, webSource, duration],
    );
    return subtitleFilters;
};

export default useSubtitleFilters;
